/* Header: header transparant + sticky zolang de hero (eerste sectie) in beeld is, daarna gevuld.
   Vervangt Impact's eigen _checkTransparency (die op 500px een schuif-animatie doet) zodat er geen hapering is. */
(function(){
  function compute(header){
    var hero=document.querySelector('.shopify-section:first-child [allow-transparent-header]');
    if(!hero){ header.classList.add('is-filled'); return; }
    var hh=header.getBoundingClientRect().height;
    var hb=hero.getBoundingClientRect().bottom;
    var open=header.querySelectorAll('[open]').length>0 || header.matches(':hover');
    header.classList.toggle('is-filled', hb<=hh+1 || open);
  }
  function patch(proto){
    proto._checkTransparency=function(){ compute(this); };
    proto._checkTransparency._stickyheader=true;
  }
  // 1) Voor theme.js: onderschep de definitie van <store-header> en vervang de methode vooraf.
  var origDefine=customElements.define.bind(customElements);
  customElements.define=function(name,cls,opts){
    if(cls && cls.prototype && typeof cls.prototype._checkTransparency==='function') patch(cls.prototype);
    return origDefine(name,cls,opts);
  };
  // 2) Vangnet als theme.js toch eerder liep: patch het element zelf en luister mee.
  function fallback(){
    var h=document.querySelector('store-header.header');
    if(!h) return;
    if(!(h._checkTransparency && h._checkTransparency._stickyheader)) patch(h);
    // Altijd zelf meeluisteren: met een sticky announcement bar roept Impact _checkTransparency
    // niet meer aan tijdens het scrollen, waardoor de header transparant bleef.
    window.addEventListener('scroll',function(){ var el=document.querySelector('store-header.header')||h; el.getAnimations().forEach(function(a){a.cancel();}); el.style.transform=''; compute(el); },{passive:true});
    window.addEventListener('resize',function(){ compute(document.querySelector('store-header.header')||h); });
    // In de thema-editor wordt de header opnieuw opgebouwd; dan opnieuw berekenen.
    document.addEventListener('shopify:section:load',function(){ var el=document.querySelector('store-header.header'); if(el) compute(el); });
    compute(h); setTimeout(function(){ compute(h); },300);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fallback); else fallback();
})();
